import axios, { AxiosRequestConfig } from "axios";
import i18next from "i18next";
import ApiError from "../utils/api/api-error";
import ApiErrorType from "../utils/api/api-error-type";
import getApiErrorMessage from "../utils/api/get-api-error-message";
import { HttpClient } from "../utils/api/http-client";
import eventManager, {
  EVENT_ERORR,
  EVENT_FORBIDDEN,
  EVENT_UNAOUTHORIZED,
} from "../utils/events";
import { ACCESS_TOKEN, LANGUAGE_CODE } from "../utils/helpers/constants";

const translateIfKnown = (message: string): string =>
  i18next.exists(message) ? i18next.t(message) : message;

export const httpclient = new HttpClient<{ token?: string }>({
  securityWorker: (data) => {
    return {
      headers: {
        authorization: `Bearer ${
          localStorage.getItem(ACCESS_TOKEN) ||
          sessionStorage.getItem(ACCESS_TOKEN)
        }`,
        "Content-Type": "application/json",
      },
    };
  },
  headers: {
    "accept-language": `${
      localStorage.getItem(LANGUAGE_CODE) ??
      process.env.REACT_APP_DEFAULT_LANGUAGE
    }`,
  },
});

httpclient.instance.interceptors.request.use(
  (config: any) => {
    config.headers["accept-language"] = `${localStorage.getItem(
      LANGUAGE_CODE,
    )}`;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
httpclient.instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }
    throw handleError(error, !isErrorNotificationSuppressed(error));
  },
);

const isErrorNotificationSuppressed = (error: any): boolean => {
  if (error?.config?.suppressErrorNotification === true) return true;

  const suppressedKeys = error?.config?.suppressErrorNotificationForKeys;
  const errorKey = error?.response?.data?.errorKey;
  return (
    Array.isArray(suppressedKeys) &&
    typeof errorKey === "string" &&
    suppressedKeys.includes(errorKey)
  );
};

export const handleError = (
  error: ApiError,
  emitNotification = true,
): ApiError => {
  let message: string;

  if (
    !navigator.onLine ||
    (error.message && error.message.toLowerCase().includes("network error"))
  ) {
    error.errorType = ApiErrorType.CONNECTION;
    message = "لا يوجد اتصال بالإنترنت، الرجاء التحقق من الشبكة.";
  } else if (error.response) {
    message = getApiErrorMessage(error, "حدث خطأ غير متوقع");

    let type: ApiErrorType;
    switch (error.response.status) {
      case 400:
      case 422:
        type = ApiErrorType.BAD_REQUEST;
        break;
      case 401:
        type = ApiErrorType.UNAUTHORIZED;
        eventManager.emit(EVENT_UNAOUTHORIZED);
        break;
      case 403:
        type = ApiErrorType.FORBIDDEN;
        eventManager.emit(EVENT_FORBIDDEN);
        break;
      case 404:
        type = ApiErrorType.NOT_FOUND;
        break;
      case 409:
        type = ApiErrorType.CONFLICT;
        break;
      case 500:
        type = ApiErrorType.INTERNAL_SERVER_ERROR;
        break;
      default:
        type = ApiErrorType.UNKNOWN;
        break;
    }

    error.errorType = type;
  } else if (error.request) {
    message = "لا يوجد اتصال بالإنترنت، الرجاء التحقق من الشبكة.";
    error.errorType = ApiErrorType.CONNECTION;
  } else {
    message = "500";
    error.errorType = ApiErrorType.UNKNOWN;
  }

  if (emitNotification) {
    eventManager.emit(EVENT_ERORR, translateIfKnown(message));
  }
  return error;
};
